import {
  ThermometerSun,
  Users,
  Activity,
  ShieldAlert,
  CalendarClock,
} from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

const IMPACTS = [
  { icon: ThermometerSun, title: "Kenyamanan Ruang Kerja", text: "Gangguan AC dapat mengurangi kenyamanan karyawan dan produktivitas." },
  { icon: Users, title: "Pengalaman Pelanggan", text: "Suhu ruangan yang tidak stabil dapat memengaruhi kenyamanan pengunjung." },
  { icon: Activity, title: "Operasional Bisnis", text: "Kerusakan mendadak berpotensi mengganggu kelancaran aktivitas usaha." },
  { icon: ShieldAlert, title: "Keandalan Fasilitas", text: "Unit yang tidak dirawat lebih berisiko mengalami gangguan tak terduga." },
  { icon: CalendarClock, title: "Perencanaan Maintenance", text: "Tanpa jadwal, perawatan cenderung reaktif dan sulit diprediksi." },
];

export const ProblemSection = () => {
  return (
    <section
      id="problem"
      data-testid="problem-section"
      className="relative bg-[#0F172A] py-20 sm:py-24 lg:py-28"
    >
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
          backgroundSize: "56px 56px",
        }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.15fr] lg:gap-16">
          {/* Left: heading */}
          <div>
            <Reveal>
              <div className="flex items-center gap-3 mb-4">
                <span className="text-sm font-bold text-[#E0A400]">01</span>
                <span className="text-sm font-bold uppercase tracking-[0.2em] text-slate-400">
                  Kenapa Ini Penting
                </span>
              </div>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="text-3xl font-extrabold leading-[1.12] tracking-tight text-white sm:text-4xl lg:text-[2.6rem]">
                Jangan Tunggu AC Bermasalah Baru Melakukan Maintenance
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-base leading-relaxed text-slate-300 sm:text-lg">
                Gangguan AC &amp; HVAC yang tidak terduga dapat berdampak pada
                banyak aspek bisnis. Preventive maintenance membantu perawatan
                dilakukan secara lebih terencana, sehingga sistem pendingin dapat
                dijaga performanya sebelum masalah mengganggu operasional.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-8 rounded-xl border border-white/10 bg-white/[0.03] p-5">
                <p className="text-sm leading-relaxed text-slate-400">
                  Pendekatan preventif mengedepankan perawatan berkala dan
                  perencanaan, bukan menunggu terjadinya kerusakan.
                </p>
              </div>
            </Reveal>
          </div>

          {/* Right: impacts */}
          <div className="flex flex-col gap-3">
            {IMPACTS.map((item, i) => {
              const Icon = item.icon;
              return (
                <Reveal key={item.title} delay={i * 0.06}>
                  <div className="group flex items-start gap-4 rounded-xl border border-white/10 bg-white/[0.03] p-5 transition-colors duration-300 hover:border-[#25D366]/40 hover:bg-white/[0.06]">
                    <span className="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-[#25D366]/10 text-[#25D366]">
                      <Icon className="h-5 w-5" />
                    </span>
                    <div>
                      <h3 className="text-base font-bold text-white">{item.title}</h3>
                      <p className="mt-1 text-sm leading-relaxed text-slate-400">
                        {item.text}
                      </p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
